import { Link, useLocation } from "react-router-dom";
import { IoIosClose } from "react-icons/io";
import { useAppSelector } from "../../../redux/hooks";
import {
  FaHome,
  FaUserShield,
  FaThList,
  FaTags,
  FaBoxOpen,
  FaShoppingCart,
  FaImage,
  FaNewspaper,
  FaFileAlt,
  FaStar,
  FaTools,
  FaSyncAlt,
} from "react-icons/fa";

const menuItems = [
  { path: "/", label: "Bảng điều khiển", icon: <FaHome /> },
  { path: "/admin", label: "Quản lý admin", icon: <FaUserShield />, superOnly: true },
  { path: "/category", label: "Danh mục", icon: <FaThList /> },
  { path: "/brand", label: "Thương hiệu", icon: <FaTags /> },
  { path: "/product", label: "Sản phẩm", icon: <FaBoxOpen /> },
  { path: "/order", label: "Đơn hàng", icon: <FaShoppingCart /> },
  { path: "/banner", label: "Banner", icon: <FaImage /> },
  { path: "/article", label: "Bài viết", icon: <FaNewspaper /> },
  { path: "/page", label: "Trang", icon: <FaFileAlt /> },
  { path: "/review", label: "Đánh giá", icon: <FaStar /> },
  { path: "/cache", label: "Xóa cache", icon: <FaSyncAlt /> },
];

export interface Props {
  handleCloseMenu: () => void;
}

export const NavbarMobile = ({ handleCloseMenu }: Props) => {
  const location = useLocation();
  const { admin } = useAppSelector((state) => state.admin);
  const isSuperAdmin = admin?.role === "super-admin";

  return (
    <div className="h-screen bg-slate-900 flex flex-col">
      {/* Brand */}
      <div className="px-5 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-linear-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center">
            <FaTools className="text-white text-xs" />
          </div>
          <p className="text-sm font-bold text-white">Thành Phát</p>
        </div>
        <button
          type="button"
          onClick={handleCloseMenu}
          className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center text-slate-400 hover:text-white cursor-pointer transition-colors"
        >
          <IoIosClose className="text-xl" />
        </button>
      </div>

      {/* Menu */}
      <nav className="flex-1 px-3 py-2 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          if (item.superOnly && !isSuperAdmin) return null;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={handleCloseMenu}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                isActive
                  ? "bg-blue-600 text-white font-medium"
                  : "text-slate-400 hover:bg-slate-800 hover:text-white"
              }`}
            >
              <span className={isActive ? "text-white" : "text-slate-500"}>
                {item.icon}
              </span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* User */}
      <div className="px-4 py-4 border-t border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center">
            <span className="text-xs font-bold text-slate-300">
              {admin?.name?.charAt(0)?.toUpperCase() ?? "A"}
            </span>
          </div>
          <p className="text-sm font-medium text-slate-200 truncate">{admin?.name}</p>
        </div>
      </div>
    </div>
  );
};
